<nz-form-item>
  <nz-form-label>Title</nz-form-label>
  <input [(ngModel)]="title" nz-input />
</nz-form-item>
<ukata-html-editor
  (onContentChange)="content = $event"
  *ngIf="displayContentField"
  [initialContent]="content"
></ukata-html-editor>
